"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ActionItemSearchServiceResponse", {
    enumerable: true,
    get: function() {
        return ActionItemSearchServiceResponse;
    }
});
const _zod = require("zod");
const _actionitem = require("../../../meetings/action-item");
const _base = require("../../base");
const ActionItemSearchServiceResponse = _base.GetBaseSearchServiceResponse.extend({
    results: _zod.z.array(_actionitem.ActionItemWithMeetingInfo)
});
